import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext({ user: null, token: null, login: () => {}, logout: () => {}, signup: () => {}, loading: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("sanaa_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    async function loadMe() {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const r = await api.get("/auth/me");
        if (mounted) setUser(r.data);
      } catch {
        localStorage.removeItem("sanaa_token");
        if (mounted) {
          setToken(null);
          setUser(null);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }
    loadMe();
    return () => {
      mounted = false;
    };
  }, [token]);

  const persist = (t, u) => {
    localStorage.setItem("sanaa_token", t);
    setToken(t);
    setUser(u);
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    persist(r.data.token, r.data.user);
    return r.data.user;
  };

  const signup = async (data) => {
    const r = await api.post("/auth/signup", data);
    persist(r.data.token, r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("sanaa_token");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, signup, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
